window.kfwHelper = {
    isMobile: function () {
        // Viewport smaller or equals 969px
        return window.matchMedia("(max-width: 60.5625rem)").matches;
    },
    isReducedMotion: function () {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
};
